<template>
    <div class="h6">{{ $t('views.onboarding.title') }}: {{$t('common.step_1')}} 2/4</div>
    <h1 class="h2">{{ $t('views.onboarding.titles.2') }}</h1>
    <p class="p">{{ $t('views.onboarding.descriptions.2') }}</p>
    <ol class="list-ordered">
        <li>
            <div class="icon-account-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.contact.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.contact.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-tag-2-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.tag.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.tag.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-message-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.log.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.log.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-database-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.export.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.export.description') }}</p>
            </div>
        </li>
    </ol>
</template>

<script>
    export default {
            name: 'OnboardingStep2'
    }
</script>
